var _rect, _rect2, _rect3, _rect4, _path, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineColumn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 213,
    viewBox: "0 0 13 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.90503,
    y: 71.0938,
    width: 17.2717,
    height: 2.03795,
    transform: "rotate(90 7.90503 71.0938)",
    fill: "#00FF00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.90503,
    y: 141.333,
    width: 17.8474,
    height: 2.03795,
    transform: "rotate(90 7.90503 141.333)",
    fill: "#FF00CA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.90503,
    y: 35.4004,
    width: 17.8474,
    height: 2.03795,
    transform: "rotate(90 7.90503 35.4004)",
    fill: "#00FF00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.90503,
    y: 106.213,
    width: 17.8474,
    height: 2.03795,
    transform: "rotate(90 7.90503 106.213)",
    fill: "#FF00CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90503 177.027L7.90503 194.299L5.86708 194.299L5.86708 177.027L7.90503 177.027Z",
    fill: "#FF00CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90503 192.027L7.90503 209.299L5.86708 209.299L5.86708 192.027L7.90503 192.027Z",
    fill: "#FF00CA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.90503,
    y: 18.127,
    width: 17.2717,
    height: 2.03795,
    transform: "rotate(90 7.90503 18.127)",
    fill: "#00FF00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.90503,
    y: 2.12695,
    width: 17.2717,
    height: 2.03795,
    transform: "rotate(90 7.90503 2.12695)",
    fill: "#00FF00"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.90503,
    y: 88.3667,
    width: 17.8474,
    height: 2.03795,
    transform: "rotate(90 7.90503 88.3667)",
    fill: "#00FF00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.90503,
    y: 159.18,
    width: 17.8474,
    height: 2.03795,
    transform: "rotate(90 7.90503 159.18)",
    fill: "#FF00CA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.90503,
    y: 53.2471,
    width: 17.8474,
    height: 2.03795,
    transform: "rotate(90 7.90503 53.2471)",
    fill: "#00FF00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.90503,
    y: 124.06,
    width: 17.2717,
    height: 2.03795,
    transform: "rotate(90 7.90503 124.06)",
    fill: "#FF00CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineColumn1);
export default __webpack_public_path__ + "static/media/line-column-1.209c0c612e943d8dea038d76d9eb9c6f.svg";
export { ForwardRef as ReactComponent };